import { SidebarPageLayout } from 'deprecated-component-library';
import { Outlet } from 'react-router-dom';

import { useScreenSize } from '@/hooks/useScreenSize';
import { SignedInPageLayout } from '@/layout/signed-in-page';
import { AccountSidebar } from '@/pages/shared/account/components';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';

export const AccountPageWrapper = () => {
  const isLargeScreen = useScreenSize() === 'large';
  const menuItems = useMenuItems();

  return (
    <SignedInPageLayout items={menuItems}>
      <SidebarPageLayout sidebar={isLargeScreen && <AccountSidebar />}>
        <Outlet />
      </SidebarPageLayout>
    </SignedInPageLayout>
  );
};
